import { render } from "./RoofType.vue?vue&type=template&id=68815462"
import script from "./RoofType.vue?vue&type=script&lang=js"
export * from "./RoofType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__